import moscow from './moscow';
import spb from './spb';
import izhevsk from './izhevsk';
import volgograd from './volgograd';
import bryansk from './bryansk';
import nizhnevartovsk from './nizhnevartovsk';
import perm from './perm';
import barnaul from './barnaul';
import rostov from './rostov';
import ufa from './ufa';

const serviceAreas = {
    moscow,
    spb,
    izhevsk,
    volgograd,
    bryansk,
    nizhnevartovsk,
    perm,
    barnaul,
    rostov,
    ufa
};

const addYmapPolygonsToServiceAreas = (serviceAreas, ymap, { debugMode = false } = {}) => {
    // Кэширование полигонов для предотвращения добавления одних и тех же полигонов на карту по нескольку раз
    const includePolygonsMap = new Map();
    const excludePolygonsMap = new Map();

    function createYmapPolygon(coordinates, isExclude) {
        const ymapPolygon = new window.ymaps.Polygon({
            type: 'Polygon',
            coordinates: coordinates,
        });

        if (debugMode) {
            if (isExclude) {
                ymapPolygon.options.set('fillColor', '#FF3434');
                ymapPolygon.options.set('strokeColor', '#FF3434');
            } else {
                ymapPolygon.options.set('fillColor', '#00aeab');
                ymapPolygon.options.set('strokeColor', '#00aeab');
            }

            ymapPolygon.options.set('fillOpacity', 0.45);
            ymapPolygon.options.set('cursor', 'default');
            ymapPolygon.options.set('interactivityModel', 'default#silent');
        } else {
            ymapPolygon.options.set('visible', false);
        }

        return ymapPolygon;
    }

    function addYmapPolygonToCart(coordinates, isExclude) {
        if (isExclude && excludePolygonsMap.get(coordinates)) {
            return excludePolygonsMap.get(coordinates);
        }

        if (!isExclude && includePolygonsMap.get(coordinates)) {
            return includePolygonsMap.get(coordinates);
        }

        const ymapPolygon = createYmapPolygon(coordinates, isExclude);

        if (isExclude) {
            excludePolygonsMap.set(coordinates, ymapPolygon);
        }

        if (!isExclude) {
            includePolygonsMap.set(coordinates, ymapPolygon);
        }

        ymap.geoObjects.add(ymapPolygon);
        return ymapPolygon;
    }

    function addYmapPolygons(obj, { isExclude= false } = {}) {
        for (const key in obj) {
            const field = obj[key];

            // для производительности, не обрабатывать координаты
            if (key === 'coordinates') return;

            if (field?.type === 'polygon') {
                const ymapPolygon = addYmapPolygonToCart(field.coordinates, isExclude);
                field.ymapPolygons = [ymapPolygon];
            } else if (typeof field === 'object') {
                addYmapPolygons(field, {
                    isExclude: isExclude || (key === 'exclude')
                });
            }
        }
    }

    addYmapPolygons(serviceAreas);
};

const checkCoordsInPolygons = (coords, ymapPolygons) => {
    return ymapPolygons.some((ymapPolygon) => {
        return ymapPolygon.geometry.contains(coords);
    });
};

const getDistanceFromGeoObject = (coords, geoObject) => {
    if (geoObject.type === 'polygon') {
        if (checkCoordsInPolygons(coords, geoObject.ymapPolygons)) {
            return 0;
        } else {
            const distances = geoObject.ymapPolygons.map((ymapPolygon) =>
                ymapPolygon.geometry.getClosest(coords).distance / 1000);
            return Math.min(...distances);
        }
    } else {
        return window.ymaps.coordSystem.geo.getDistance(coords, geoObject.coordinates) / 1000;
    }
};

const getSuitableGeoObjectInServiceArea = (coords, serviceArea) => {
    const { include, exclude } = serviceArea;

    const suitableGeoObject = include.find((geoObject) => {
        if (geoObject.distance) {
            const distance = getDistanceFromGeoObject(coords, geoObject);
            return (distance <= geoObject.maxDistance) && (distance > 0);
        } else {
            if (geoObject.type === 'polygon') {
                return checkCoordsInPolygons(coords, geoObject.ymapPolygons);
            }
        }
    });

    if (suitableGeoObject) {
        if (exclude) {
            const isAddressInExclude = exclude.some((geoObject) => {
                if (geoObject.type === 'polygon') {
                    return checkCoordsInPolygons(coords, geoObject.ymapPolygons);
                }
            });

            if (!isAddressInExclude) {
                return suitableGeoObject;
            }
        } else {
            return suitableGeoObject;
        }
    }

    return null;
};

const getMedsiServiceAreaByCoords = (coords) => {
    const cityNames = Object.keys(serviceAreas);

    for (let i = 0; i < cityNames.length; i++) {
        const cityName = cityNames[i];
        const { serviceAreas: cityServiceAreas, regionCode } = serviceAreas[cityName];

        for (let j = 0; j < cityServiceAreas.length; j++) {
            const serviceArea = cityServiceAreas[j];
            const suitableGeoObject = getSuitableGeoObjectInServiceArea(coords, serviceArea);

            if (suitableGeoObject) {
                const result = {
                    id: serviceArea.id,
                    regionCode,
                    geoObjectName: suitableGeoObject.name,
                    detail: {
                        serviceArea: serviceArea,
                        geoObject: suitableGeoObject,
                    },
                };

                if (suitableGeoObject.distance) {
                    result.distance = getDistanceFromGeoObject(coords, suitableGeoObject);
                }

                return result;
            }
        }
    }

    return null;
}

export {
    serviceAreas,
    addYmapPolygonsToServiceAreas,
    getMedsiServiceAreaByCoords
}
